<section class="full-value-popover" [attr.aria-label]="label + ' full value'">
  <header class="full-value-popover__header">
    <div class="full-value-popover__identity">
      <h3>{{ label }}</h3>
    </div>
  </header>
  <div class="full-value-popover__body">
    <p [attr.aria-label]="label + ' value'">{{ value || 'N/A' }}</p>
    <button #tooltip="matTooltip" mat-icon-button type="button" [disableRipple]="true"
      class="full-value-popover__copy" (click)="copyToClipboard(tooltip, value)"
      [matTooltip]="copied ? 'Copied!' : 'Copy'" [attr.aria-label]="'Copy ' + label + ' value'">
      <mat-icon aria-hidden="true">{{ copied ? 'check' : 'content_copy' }}</mat-icon>
    </button>
  </div>
</section>
